import { DeviceOffFarmCheckpointEnum } from '@halter-corp/fleet-service-client';

import HttpApiService from './http-api.service';

const FleetService = {
  setOffFarmCheckpoint: async (serialNumbers: string[], checkpoint: DeviceOffFarmCheckpointEnum) => {
    const api = await HttpApiService.getDeviceOffFarmApi();
    try {
      const { data } = await api.setDevicesOffFarmCheckpointReached({ serialNumbers, checkpoint });
      return data;
    } catch (err) {
      return undefined;
    }
  },

  setArriveAtHalterCheckpoint: async (boxIds: string[]) => {
    const api = await HttpApiService.getDeviceOffFarmApi();
    try {
      const { data } = await api.setDevicesHalterArrivalCheckpointReached({ deviceBoxIds: boxIds });
      return data;
    } catch (err) {
      return undefined;
    }
  },
};

export default FleetService;
